import { cloneDeep } from "lodash";
import { websiteBuilderInitialEditor, IWebsiteBuilderEditor, websiteBuilderEditorReducer } from "./websiteBuilderEditor";
import { websiteBuilderInitialConfig, IWebsiteBuilderConfig, websiteBuilderConfigReducer } from "./websiteBuilderConfig";
import { isWebsiteBuilderConfigAction } from "redux/actions/websiteBuilder/config/websiteBuilderConfigAction";
import { isWebsiteBuilderEditorAction } from "redux/actions/websiteBuilder/editor/websiteBuilderEditorAction";
import { AuthActionTypes } from "redux/actions/actionTypes";
import { AnyAction } from "redux";

interface IWebsiteBuilderState {
  config: IWebsiteBuilderConfig;
  editor: IWebsiteBuilderEditor;
}

const initialState: IWebsiteBuilderState = {
  config: cloneDeep(websiteBuilderInitialConfig),
  editor: cloneDeep(websiteBuilderInitialEditor),
};

export function WebsiteBuilderReducer(state = cloneDeep(initialState), action: AnyAction): IWebsiteBuilderState {
  if (action.type === AuthActionTypes.USER_LOGIN || action.type === AuthActionTypes.USER_LOGOUT) {
    return cloneDeep(initialState);
  } else if (isWebsiteBuilderConfigAction(action)) {
    return {
      ...state,
      config: websiteBuilderConfigReducer(state.config, action),
    };
  } else if (isWebsiteBuilderEditorAction(action)) {
    return {
      ...state,
      editor: websiteBuilderEditorReducer(state.editor, action),
    };
  } else {
    return state;
  }
}
